import { createFileRoute } from "@tanstack/react-router"
import { EsiaAuthPage } from "@/pages/esia-auth"

export const Route = createFileRoute("/(analytics)/esia-auth")({
	component: EsiaAuthPage,
})
